(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58204],{

/***/ 5669:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials",
      function () {
        return __webpack_require__(2953);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ tutorials; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/partials/Header.js
var Header = __webpack_require__(86518);
// EXTERNAL MODULE: ./src/partials/FooterOLD2.js
var FooterOLD2 = __webpack_require__(93781);
// EXTERNAL MODULE: ./src/partials/TutorialsList.js
var TutorialsList = __webpack_require__(45497);
// EXTERNAL MODULE: ./src/partials/Newsletter.js
var Newsletter = __webpack_require__(46521);
// EXTERNAL MODULE: ./src/partials/YoutubeTutorialsList.js
var YoutubeTutorialsList = __webpack_require__(87218);
;// CONCATENATED MODULE: ./src/partials/TutorialsNewsletter.js


function TutorialsNewsletter() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-6xl mx-auto px-4 sm:px-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-12 md:pb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative bg-gray-100 rounded py-10 px-8 md:py-16 md:px-12 shadow-2xl overflow-hidden",
                    "data-aos": "zoom-y-out",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute right-0 bottom-0 pointer-events-none hidden lg:block",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "428",
                                height: "328",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                                            cx: "35.542%",
                                            cy: "34.553%",
                                            fx: "35.542%",
                                            fy: "34.553%",
                                            r: "96.031%",
                                            id: "ni-a",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0.25"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                    offset: "1",
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                        fill: "none",
                                        fillRule: "evenodd",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                fill: "#34CDB1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        fillOpacity: ".04",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "16",
                                                        ry: "15.576"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        fillOpacity: ".24",
                                                        cx: "100",
                                                        cy: "68.402",
                                                        rx: "24",
                                                        ry: "23.364"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "29",
                                                        ry: "28.231"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "342",
                                                        cy: "31.303",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        fillOpacity: ".48",
                                                        cx: "62",
                                                        cy: "126.811",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "78",
                                                        cy: "7.072",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "6",
                                                        ry: "5.841"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                fill: "url(#ni-a)",
                                                cx: "276",
                                                cy: "237",
                                                r: "200"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative flex flex-col lg:flex-row justify-between items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center lg:text-left lg:max-w-xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "h3 text-black mb-2",
                                        children: "Got Questions?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-gray-700 text-lg mb-6",
                                        children: "Ask the questions in the community forum, we'll happy to assist."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        className: "w-full lg:w-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col sm:flex-row justify-start max-w-xs mx-auto sm:max-w-md lg:mx-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "btn text-white bg-blue-600 hover:bg-blue-700 shadow",
                                                    href: "https://community.tradly.app?utm_source=tradly.app&utm_medium=tutorials",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "JOIN COMMUNITY"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm text-gray-400 mt-3",
                                                children: "No spam. You can unsubscribe at any time."
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var partials_TutorialsNewsletter = (TutorialsNewsletter);

// EXTERNAL MODULE: ./src/partials/TradlyFooter.js + 4 modules
var TradlyFooter = __webpack_require__(48777);
;// CONCATENATED MODULE: ./src/pages/tutorials/index.js










function Tutorials() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Tradly – Tutorials"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col min-h-screen overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "flex-grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeTutorialsList/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_TutorialsNewsletter, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TradlyFooter/* default */.Z, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var tutorials = (Tutorials);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [48777,87218,82495,49774,92888,40179], function() { return __webpack_exec__(5669); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);